module.exports = __webpack_public_path__ + "img/img_communication_24.34b0d020.jpg";